document.addEventListener('DOMContentLoaded', () => {
   
    function intersect(items) {
        items.forEach((item) => {
            if (item.isIntersecting) {
                item.target.classList.remove('preload');
                item.target.classList.add('loaded');
            }
        });
    }

    let options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    }
    const observer = new IntersectionObserver(intersect, options);
    const sections = document.querySelectorAll('.fade-in, .slide-up, .slide-left, .slide-down');
    if (sections.length > 0) {

        sections.forEach((item) => {
            item.classList.add('preload');
            observer.observe(item);
        });
    }
});